import {Injectable} from '@angular/core';
import {TorchAPIConfiguration} from '../../../config/api.configuration';
import {HttpClient} from '@angular/common/http';
import {Burly} from 'kb-burly';
import {Observable, timer} from 'rxjs';
import {switchMap} from 'rxjs/operators';
import {StockPriceIex} from '@backend/modules/@users/models/stock-price-iex.model';
import {Cacheable} from 'ts-cacheable';

@Injectable({
  providedIn: 'root'
})
export class TorchStatsService {

  interval$ = timer(1, 180000);
  latestStockPrice$ = this.interval$.pipe(switchMap(_ => this.getStockPriceIex()));

  constructor(protected config: TorchAPIConfiguration, private httpClient: HttpClient) {
  }

  @Cacheable({
    maxAge: 180000
  })
  getStockPriceIex(): Observable<StockPriceIex> {
    const endpointURL = Burly(this.config.rootUrl)
      .addSegment('/stats/stockPriceIex')
      .get;

    return this.httpClient.get<StockPriceIex>(endpointURL);
  }
}
